import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { DataLayer } from '@alfa-bank/site-data-layer';
import { PromoCardMobileV2 as PromoCard } from '@alfa-bank/site-promo-card-v2/mobile';
import { NamedContainer } from '@alfa-bank/site-named-container';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { Link } from '@alfa-bank/site-link';

import type { IDeps, TBanner } from './models';
import { MenuBanner as Component } from './menu-banner';

export const MenuBanner = createWidget<IDeps, TBanner>({
    DataLayer,
    PromoCard,
    Link,
    NamedContainer,
    Text,
    Button,
})(Component);
